import { Icon } from '@gitbook/spine-icons';
import { Button, type ButtonProps, DialogRoot, DialogTrigger } from '@gitbook/spine-react';

import {
    CreateSiteSectionGroupDialog,
    type CreateSiteSectionGroupDialogProps,
} from './CreateSiteSectionGroupDialog';

interface CreateSiteSectionGroupButtonProps
    extends CreateSiteSectionGroupDialogProps,
        Pick<ButtonProps, 'className' | 'label' | 'size' | 'kind'> {}

export function CreateSiteSectionGroupButton(props: CreateSiteSectionGroupButtonProps) {
    const { className, label, size, kind = 'secondary', ...dialogProps } = props;
    return (
        <DialogRoot>
            <DialogTrigger>
                <Button
                    leadingIcon={Icon.AddSiteGroup}
                    label={label}
                    className={className}
                    size={size}
                    kind={kind}
                />
            </DialogTrigger>
            <CreateSiteSectionGroupDialog {...dialogProps} />
        </DialogRoot>
    );
}
